import { createActions } from 'redux-actions';
export const timelineActions = createActions('TIMELINE_GET_REQUEST', 'TIMELINE_GET_SUCCEEDED', 'TIMELINE_GET_FAILED', 'TIMELINE_CLEAR', 'TIMELINE_SET_GRANULARITY');
